<template>
  <gw-card class="a7-card-detalhe">
    <div slot="header">
      <div class="a7-line-chart-header">
        <span class="header-title">Histórico do indicador</span>
        <div class="a7-options">
          <div class="a7-options-item intervalo">
            <span class="item-title">Intervalo</span>
            <gw-select
              :data="options"
              representation-field="label"
              representation-value="value"
              v-model="tipoIntervaloHistorico"
            />
          </div>
          <div class="a7-options-item quantidade">
            <span class="item-title">Quantidade</span>
            <input type="number" :min="0" v-model="qtdHistorico">
          </div>
        </div>
      </div>
    </div>
    <div slot="body">
      <div class="body-chart">
        <gw-cartesian-chart v-if="exibirGrafico" :labels="labels" :width="200" :height="200">
          <gw-line-dataset label="Desempenho" :data="chartData"/>
          <gw-scales>
            <gw-y-axis :formatter="percentFormat"/>
          </gw-scales>
        </gw-cartesian-chart>
        <gw-button v-if="!exibirGrafico" class="default" @click="exibirGrafico = true">
          Atualizar
        </gw-button>
      </div>
    </div>
  </gw-card>
</template>

<script>
import {
  GwCard,
  Formatters,
  GwSelect,
  GwCartesianChart,
  GwLineDataset,
  GwScales,
  GwYAxis,
  FilterUtilities,
  GwButton
} from "guaxinim-web";
import MedicaoIndicadorRestResource from "./MedicaoIndicadorRestResource";

export default {
  name: "a7-historico-indicador",
  components: {
    GwCard,
    Formatters,
    GwSelect,
    GwCartesianChart,
    GwLineDataset,
    GwScales,
    GwYAxis,
    FilterUtilities,
    MedicaoIndicadorRestResource,
    GwButton
  },
  props: {
    painelIndicadorDTO: {
      type: Object,
      default: {}
    },
    filterParams: null
  },
  data() {
    const vm = this;

    return {
      tipoIntervaloHistorico: "day",
      qtdHistorico: 10,
      options: [
        {
          label: "Dia",
          value: "day"
        },
        {
          label: "Semana",
          value: "week"
        },
        {
          label: "Mês",
          value: "month"
        },
        {
          label: "Trimestre",
          value: "quarter"
        },
        {
          label: "Semestre",
          value: "half"
        },
        {
          label: "Ano",
          value: "year"
        }
      ],
      exibirGrafico: false,
      labels: [],
      chartData: [],
      percentFormat: Formatters.percentFormat.format
    }
  },
  watch: {
    filterParams() {
      this.exibirGrafico = false;
    },
    painelIndicadorDTO() {
      this.exibirGrafico = false;
    },
    qtdHistorico() {
      this.exibirGrafico = false;
    },
    tipoIntervaloHistorico() {
      this.exibirGrafico = false;
    },
    exibirGrafico(newValue) {
      if (newValue) {
        this.resetarGrafico();
        this.buscarDadosHistorico();
      }
    }
  },
  methods: {
    resetarGrafico() {
      this.chartData = [];
    },
    buscarDadosHistorico() {
      const vm = this;

      if (!this.painelIndicadorDTO) {
        vm.resetarGrafico();
        return;
      }

      const dtoPainel = JSON.parse(JSON.stringify(this.painelIndicadorDTO));
      dtoPainel.filhos = null;

      this.heavyTask(
        MedicaoIndicadorRestResource.getHistorico(
          FilterUtilities.createFilterParamsString(this.filterParams),
          JSON.stringify(dtoPainel),
          vm.tipoIntervaloHistorico,
          vm.qtdHistorico || 0
        )
        .then(historico => {
          const valores = historico.map(h => (h ? h.valor : null));
          const labels = historico.map(h =>
            h ? Formatters.dateFormat.format(new Date(h.data)) : null
          );

          vm.labels = labels;
          vm.chartData = valores;
        })
        .catch(err => {
          vm.labels = [];
          vm.chartData = [];
          this.$gw.defaultExceptionHandler.handleUnknownException(err, this);
        })
      );
    }
  }
}
</script>

<style lang="scss" scoped>
@import '/A7PainelFormatacao';
.a7-card-detalhe {
  flex-grow: 1;
  min-width: 200px;
  position: relative;
  display: block!important;
}

.a7-line-chart-header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: none !important;
  padding-bottom: 10px;
  width: 100%;
  .header-title{
    font-size: $tamanhoFonteGrande;
    min-width: 170px;
  }
  .a7-options {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex:1;
    .a7-options-item {
      display: flex;
      flex-direction: column;
      margin-right: 5px;
      .item-title {
        font-size: $tamanhoFontePequena;
      }
      &.intervalo{
        min-width: 95px;
      }
      &.quantidade{
        width: 70px;
      }
    }
  }
  @include md {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .a7-options {
      .a7-options-item{
        margin: 0px 5px;
      }
    }
  }
}

.body-chart {
  height: 200px;
  padding-top: 10px;
  text-align: center;
  display: block;
  position: relative;
}

.body-chart button {
  position: absolute;
  top: 50%;
}
</style>
